import { useState } from 'react'
import InvisibleCaptcha from '../InvisibleCaptcha'
import Button from '@talkdesk/cobalt-react-button'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'

const SecureForm = ({
  children,
  submitLabel,
  siteKey,
  disabledForm,
  onSubmit,
  onExecuteRecaptcha,
  isFormValid,
  isDanger = false,
}) => {
  const hasRecaptcha = siteKey !== ''
  const [recaptchaInstance, setRecaptchaInstance] = useState(null)

  const isSubmitDisabled =
    disabledForm || !isFormValid || (hasRecaptcha && !recaptchaInstance)

  const handleFormSubmit = (event) => {
    event.preventDefault()
    if (isSubmitDisabled) {
      return
    }
    if (hasRecaptcha) {
      onExecuteRecaptcha()
      recaptchaInstance.execute()
    } else {
      onSubmit()
    }
  }

  const submitButton = (
    <Box paddingY='2' width='100%'>
      <Button
        htmlType='submit'
        disabled={isSubmitDisabled}
        shape='full-width'
        type={isDanger ? 'danger' : 'primary'}
      >
        {submitLabel}
      </Button>
    </Box>
  )

  return (
    <Box paddingY='2' width='100%'>
      <form onSubmit={handleFormSubmit}>
        {children}
        {hasRecaptcha ? (
          <Flex direction='column' gap='2'>
            <InvisibleCaptcha
              siteKey={siteKey}
              instance={recaptchaInstance}
              onRecaptchaRendered={setRecaptchaInstance}
              onSubmit={onSubmit}
            />
            {submitButton}
          </Flex>
        ) : (
          submitButton
        )}
      </form>
    </Box>
  )
}

export default SecureForm
